<template>
  <div class="submitBox" v-show="sumitBoxState">
    <div class="sub_div_one">
      <span v-if="identity=='供应商'">
        亲，会尽快为您提供产品及价格回复。 您的会员手机号是：
      </span>
      <span v-else>
        亲，马上为您安排专业{{identity}}和您对接，您希望 
        <el-select :popper-append-to-body="false" v-model="customizerNum" size="mini" style="width:0.7rem" placeholder="请选择">
          <el-option v-for="item in 3" :key="item" :label="item" :value="item">
          </el-option>
        </el-select> 
        位{{identity}}和您联系？您的会员手机号是：
      </span>
      {{$store.state.userInfor.phoneNumber}}，
      是否需要补充您的第二联系号码 
      <el-input v-model="sparePhone" placeholder="联系电话" style="width:1.2rem" maxlength="11" size="mini"
        @input="sparePhone=sparePhone.replace(/[^\d]/g,'')"></el-input> 
      方便第一时间把方案送到您的手上。
    </div>
    <div class="sub_div_two">
      <div v-if="requestState" class="sub_div_success">询价已发送成功</div>
      <button v-if="!requestState" @click="sumitBoxState = false;" 
        style="background:#fff;border:1px solid #dcdcdc;color:#333;">再想想</button>
      <button v-else @click="sumitBoxState = false;" style="background:#fff;border:1px solid #dcdcdc;color:#333;">关闭</button>
      <button v-if="!requestState" @click="saveSubmitAll">发送</button>
      <button v-else @click="goMyInquiry">查看已发送的询价</button>
    </div>
    <div class="sub_div_three cleanFloat">
      <div class="sdt_left">
        <span>提醒：</span>
        <ul>
          <li>1）将在24小时内收到{{identity}}给您的回复；</li>
          <li>2）请您扫描并关注右侧二维码，{{identity}}给您报价后，您将第一时间收到；</li>
        </ul>
      </div>
      <div class="sdt_right">
        <img src="../../assets/jpg/xiaochengxu.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/components/Api/index.js'
export default {
  data(){
    return{
      sumitBoxState:false,
      customizerNum:2,
      sparePhone:null,
      requestState:false,
      saveObj:{},
    }
  },
  props:{
    identity:{
      type:String,
      default:'',
    },
  },
  methods:{
    saveSubmitAll(){
      if(this.identity=='供应商'){
        this.$set(this.saveObj,"phoneOne",this.$store.state.userInfor.phoneNumber)
        this.$set(this.saveObj,"phoneTwo",this.sparePhone)
        this.$set(this.saveObj,"budgetMainId",this.$store.state.budgetMainId)
        new Api('inquiry').projectInquiryAdd(this.saveObj).then(res => {
          if (res.status == 200) {
            this.requestState = true
            this.$message({ type: "success",message: "保存成功"}); 
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }else{
        this.saveObj.telephone = this.$store.state.userInfor.phoneNumber
        this.saveObj.inquiryMaintainList[0].standbyTelephone = this.sparePhone
        this.saveObj.customizerNumber  =this.customizerNum
        new Api('inquiry').informationInquiryAdd(this.saveObj).then(res => {
          if (res.status == 200) {
            this.requestState = true
            this.$message({ type: "success",message: "保存成功"}); 
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }
    },
    goMyInquiry(){
      this.$emit("closeDialog")
      this.sumitBoxState=false
      this.$store.commit("setRightPopupIndex",1)
      this.$router.push({
        name: "plan",
        query:{
          index:2
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.submitBox {
  font-size: 0.14rem;
  position: absolute;
  top: 56px;
  right: 0;
  background: #fff;
  width: 5.4rem;
  border: 0.08rem solid #db4e1a;
  border-radius: 20px;
  padding: 0.24rem;
  z-index: 3000;
  .sub_div_one {
    line-height: 0.3rem;
  }
  .sub_div_two {
    text-align: center;
    .sub_div_success {
      margin-top: 10px;
      color: red;
    }
    button{
      background: #e65019;
      height: 0.35rem;
      margin: 0.2rem 0.04rem;
      border-radius: 5px;
      border: none;
      width: 1.3rem;
      color: #fff;
    }
  } 
  .sub_div_three{
    display: flex;
    ul{
      margin-top: 0.15rem;
      li{
        margin: 0.05rem 0;
        line-height: 0.25rem;
      }
    }
    .sdt_right img {
      width: 1.2rem;
      height: 1.2rem;
    }
  }
}
</style>